// extracted by mini-css-extract-plugin
export default {"rotating":"PDFFilePreview_rotating__TfFtu"};